export default __webpack_public_path__ + "2a4d142de9a7c4fa3f7cfed68bf36ad0.png";